import { styled } from "@mui/system";
import { FIGMA_COLORS } from "components-redesign/styles";
import TYPOGRAPHY from "../styles/typography";

export const TypographyDisplayLarge = styled("div")(TYPOGRAPHY.displayLarge);
export const TypographyDisplayMedium = styled("div")(TYPOGRAPHY.displayMedium);
export const TypographyDisplaySmall = styled("div")(TYPOGRAPHY.displaySmall);

export const TypographyHeadlineLarge = styled("div")(TYPOGRAPHY.headlineLarge);
export const TypographyHeadlineMedium = styled("div")(
  TYPOGRAPHY.headlineMedium
);
export const TypographyHeadlineMediumStatic500 = styled("div")({
  ...TYPOGRAPHY.headlineMediumStatic,
  fontWeight: 500,
});
export const TypographyHeadlineMedium600 = styled("div")({
  ...TYPOGRAPHY.headlineMedium,
  fontWeight: 600,
});
export const TypographyHeadlineSmall = styled("div")(TYPOGRAPHY.headlineSmall);
export const TypographyHeadlineSmall600 = styled("div")({
  ...TYPOGRAPHY.headlineSmall,
  fontWeight: 600,
});

export const TypographyTitleLarge = styled("div")(TYPOGRAPHY.titleLarge);
export const TypographyTitleMedium = styled("div")(TYPOGRAPHY.titleMedium);
export const TypographyTitleMedium600 = styled("div")({
  ...TYPOGRAPHY.titleMedium,
  fontWeight: 600,
});
export const TypographyTitleSmall = styled("div")(TYPOGRAPHY.titleSmall);

export const TypographyBodyLarge = styled("div")(TYPOGRAPHY.bodyLarge);
export const TypographyBodyMedium = styled("div")(TYPOGRAPHY.bodyMedium);
export const TypographyBodyMedium500 = styled("div")({
  ...TYPOGRAPHY.bodyMedium,
  fontWeight: 500,
});
export const TypographyBodyMedium600 = styled("div")({
  ...TYPOGRAPHY.bodyMedium,
  fontWeight: 600,
});
export const TypographyBodyMedium2 = styled("div")(TYPOGRAPHY.bodyMedium2);
export const TypographyBodySmall = styled("div")(TYPOGRAPHY.bodySmall);
export const TypographyBodyXSmall = styled("div")(TYPOGRAPHY.bodyXSmall);

export const TypographyLabelLarge = styled("div")(TYPOGRAPHY.labelLarge);
export const TypographyLabelMedium = styled("div")(TYPOGRAPHY.labelMedium);
export const TypographyLabelSmall = styled("div")(TYPOGRAPHY.labelSmall);

export const TypographyError = styled("div")({
  color: FIGMA_COLORS.errorLight,
});
